import * as React from 'react';
import clsx from 'clsx';
import { FiltersMenu } from './FiltersMenu';
import type { FiltersMenuProps } from './FiltersMenu';
import type { Filter } from './Filters';
import styles from './ListFilterBar.module.css';

export interface ListFilterBarProps<T = unknown> {
  /** Fields for the default `FiltersMenu`; omit when passing `children`. */
  fields?: FiltersMenuProps<T>['fields'];
  filters: Filter<T>[];
  onChange: (filters: Filter<T>[]) => void;
  /** Label for the reset button (default: "Clear") */
  clearLabel?: string;
  className?: string;
  /**
   * Filters control to render in place of the default `FiltersMenu` — use for
   * pages built on the inline `Filters` variant instead.
   */
  children?: React.ReactNode;
}

/**
 * A list page's filter row: the filters control plus a Clear button that
 * appears only once at least one filter is active. Clearing routes through the
 * same `onChange` as any other filter edit, so page-reset side effects stay put.
 */
export function ListFilterBar<T = unknown>({
  fields,
  filters,
  onChange,
  clearLabel = 'Clear',
  className,
  children,
}: ListFilterBarProps<T>) {
  return (
    <div className={clsx(styles.listFilterBar, className)}>
      <div className={styles.menu}>
        {children ?? <FiltersMenu fields={fields!} filters={filters} onChange={onChange} />}
      </div>
      {filters.length > 0 && (
        <button type="button" className={styles.clear} onClick={() => onChange([])}>
          {clearLabel}
        </button>
      )}
    </div>
  );
}
